import { defineStore } from 'pinia'
export default defineStore({
  id: 'bankAccountDataTable',
  persist: true,
  state: () => {
    return {
      isBankAccountArchive: false
    }
  },
  actions: {
    setIsBankAccountArchive: function (payload: any) {
      this.isBankAccountArchive = payload
    }
  },
  getters: {
    getIsBankAccountArchive: (state: any) => state.isBankAccountArchive
  }
})
